export const REQUEST_SHIPMENT_DETAILS_DATA = "REQUEST_SHIPMENT_DETAILS_DATA";
export const RECEIVE_SHIPMENT_DETAILS_DATA = "RECEIVE_SHIPMENT_DETAILS_DATA";

export const requestShipmentDetailsData = (payload) => ({
  type: REQUEST_SHIPMENT_DETAILS_DATA,
  payload
});

export const receiveShipmentDetailsData = payload => ({type: RECEIVE_SHIPMENT_DETAILS_DATA, payload: payload});


// WEBPACK FOOTER //
// ./src/actions/shipmentDetailsDataActions.js